var map = {
	"./CRM客户管理.png": 142,
	"./FMS财务管理.png": 8795,
	"./HR人力管理.png": 1904,
	"./IoT智能设备互联.png": 6889,
	"./OMS订单管理.png": 6691,
	"./TMS运输管理.png": 1666,
	"./WMS仓储管理.png": 8641,
	"./云司机.png": 6024,
	"./企业OA.png": 7659,
	"./关于运脉.png": 3134,
	"./冷链运输平台.png": 2238,
	"./制造与商贸企业平台.png": 6563,
	"./危化运输平台.png": 166,
	"./商砼运输平台.png": 9761,
	"./家具配送平台.png": 6647,
	"./应用中心.png": 955,
	"./开发合作.png": 9798,
	"./数字物流技术平台.png": 2838,
	"./数字物流技术平台1.png": 5675,
	"./数智车务.png": 3532,
	"./渠道合作.png": 4015,
	"./物流承运商平台.png": 5676,
	"./物流承运商平台2.png": 7206,
	"./生态合作.png": 9370,
	"./运脉云OS.png": 3280
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7642;